export default {
  "ORDER_WAIT_SHIP": "Menunggu pengiriman",
  "Men fashion": "Pakaian pria",
  "MyAccount_MyProfile_label_First": "Nama depan",
  "MyAccount_MyShippingDetails_Phone": "Nomor telepon",
  "Page_not_found_message1": "Maaf, halaman tidak ditemukan",
  "Help": "Bantuan",
  "Sign in": "Masuk",
  "Register": "Daftar",
  "Category_sorting_Item": "Pilih cara pengurutan",
  "cart_clear": "Kosongkan keranjang belanja",
  "Payment & Delivery": "Pembayaran & Pengiriman",
  "Send my feedback": "Kirim umpan balik saya",
  "MyAccount_MyProfile_Save": "Simpan perubahan",
  "Continue_billing": "Lanjutkan pembayaran",
  "Categories": "Kategori",
  "Read and understand": "Saya telah membaca dan memahami",
  "Feel free to edit": "Edit informasi detail Anda kapan saja untuk menjaga akun Anda tetap terbaru",
  "Select payment method": "Pilih metode pembayaran",
  "Login_input_email": "Email",
  "Login_input_first": "Nama depan",
  "Account": "Akun",
  "Create_Time_Asc": "Waktu pembuatan dari kecil ke besar",
  "concactus_label": "Pendapat atau pertanyaan",
  "Order_Grade": "Penilaian pesanan",
  "wishlist_empty_desc": "Tidak ada produk yang ditambahkan ke wishlist Anda",
  "cartpreviewShipping_messageinfo": "Anda akan menerima konfirmasi pengiriman dan tanggal kedatangan",
  "unsubscribe": "Anda dapat membatalkan berlangganan kapan saja",
  "prompt": "Prompt",
  "MyAccount_MyProfile_yinsi_message": "Di Brand Name, kami sangat memperhatikan privasi dan melindungi data pribadi pengguna. Untuk informasi detail tentang bagaimana kami peduli dan menggunakan data pribadi Anda, mohon baca",
  "About us": "Tentang kami",
  "or": "atau",
  "MyAccount_Order_History_All": "Semua pesanan",
  "What_We_Improve": "Bagaimana kami meningkatkan?",
  "MyAccount_ShippingDetails_title": "Detail pengiriman",
  "MyAccount_Order_History_Tabs2": "Belum dibayar",
  "Go_back_shopping": "Kembali ke belanja",
  "Product": "Produk",
  "Order summary": "Ringkasan pesanan",
  "payment_order_total": "Total biaya pesanan",
  "Departments": "Pernyataan hukum",
  "Download": "Unduh",
  "Your_Purchase_Order": "Pesanan Anda",
  "Your_Account": "Akun Anda",
  "order_after_sales_list_null": "Saat ini Anda tidak memiliki pesanan layanan purna jual",
  "All_After_sales_orders": "Semua pesanan layanan purna jual",
  "Filters": "Penyaringan",
  "search_results_not": "Kami tidak menemukan hasil terkait dengan frasa yang diberikan",
  "ORDER_WAIT_RECEIPT": "Menunggu diterima",
  "ORDER_CLOSED": "Ditutup",
  "Order_View_details": "Lihat Rincian",
  "Subscribe_to_message": "Dapatkan penjualan dan kegiatan yang akan datang. Dapatkan hadiah dan penawaran khusus!",
  "TaxFee": "Pajak biaya",
  "Apply": "Menerapkan",
  "Total_price": "Total harga",
  "Description": "Deskripsi",
  "Payment method": "Metode pembayaran",
  "Back": "Kembali",
  "Empty": "Sepertinya Anda belum menambahkan produk apa pun ke dalam tas belanja Anda. Mulailah belanja untuk mengisinya.",
  "After_sales": "Jualan setelah",
  "Instruction3": "Ya , kami tahu",
  "MyAccount_MyShippingDetails_Last": "Nama belakang",
  "MyAccount_MyShippingDetails_City": "Kota",
  "payment_order_discount": "Diskon pesanan",
  "MyAccount_Order": "Detail pesanan",
  "ID_Name_Error": "Harap masukkan nama Identitas Anda",
  "Kidswear": "Busana Anak",
  "Share your look": "Bagikan tampilan Anda",
  "Pay_Order": "Bayar pesanan",
  "Reset_Password": "Atur ulang kata sandi",
  "MyAccount_MyProfile_label2_pass1": "Kata sandi saat ini",
  "Create_Time_Desc": "Waktu dibuat menurun",
  "Items": "Item",
  "Login_Register": "Daftar sekarang",
  "Back to homepage": "Kembali ke homepage",
  "switch_CNY": "Ubah menjadi RMB",
  "Successful placed order": "Anda telah berhasil melakukan pesanan. Anda dapat menggunakan fungsi status pengiriman kami untuk memeriksa status pesanan Anda. Anda akan menerima email konfirmasi pesanan yang berisi informasi detail dan tautan pelacakan.",
  "MyAccount_MyProfile_yinsi_link": "Kebijakan privasi",
  "Order_Date": "Tanggal pesanan",
  "Allow order notifications": "Perbolehkan pemberitahuan pesanan",
  "MyAccount_MyProfile_Tab1": "Profil",
  "MyAccount_ShippingDetails_changeTitle": "Ubah alamat",
  "ID_Number": "Nomor identitas",
  "Order_after_sales_message": "Detail dan Pesanan Jualan Setelah",
  "MyAccount_MyProfile_title2": "Jika Anda ingin mengubah kata sandi untuk mengakses akun Anda, masukkan informasi berikut:",
  "Customer service": "Layanan pelanggan",
  "MyAccount_MyProfile_Update": "Perbarui kata sandi",
  "choose_language": "Pilih bahasa",
  "ORDER_REFUNDING": "Refund pesanan",
  "MyAccount_MyProfile_title1": "Sunting informasi detail di bawah ini kapan saja agar akun Anda tetap terbaru",
  "ORDER_WAIT_RATE": "Menunggu rating",
  "after_sales_refund_order": "Pesanan pengembalian dana",
  "Who we are": "Kami siapa",
  "Women fashion": "Fashion Wanita",
  "Personal details": "detail personal",
  "Password": "kata sandi",
  "wishlist_empty_title": "Daftar Keinginan Anda Kosong",
  "Repeat_Password": "ulangi kata sandi",
  "cart_price": "subtotal",
  "Sort_by": "urut berdasarkan",
  "Customer Reviews": "ulasan pelanggan",
  "Continue to shipping": "Lanjut ke pengiriman",
  "payment_make_order": "memesan",
  "save_order_review": "kirim ulasan",
  "Save_Password": "simpan kata sandi",
  "cart_empty_title": "Keranjang belanja Anda kosong",
  "TopBar_help": "Bantuan dan Pertanyaan Umum",
  "colseCookie": "Saya mengerti",
  "Password_Changed": "Kata sandi berhasil diubah. Anda dapat kembali ke halaman utama dan masuk.",
  "Forgot Password Modal Email": "Email Anda yang digunakan untuk masuk:",
  "MyAccount_Personal": "detail personal",
  "cartPreviewShipping": "pengiriman mudah",
  "ORDER_AFTER_SALE": "dalam penjualan",
  "Page_not_found": "halaman tidak ditemukan",
  "Find out more": "Pelajari lebih lanjut",
  "Log into your account": "Masuk ke akun Anda",
  "Details_and_status_orders": "Periksa rincian dan status pesanan di toko online. Anda juga dapat membatalkan atau mengembalikan pesanan.",
  "Order_to_be_paid_message": "menunggu pembayaran",
  "Guarantee": "garansi",
  "Sections that interest you": "Bagian-bagian yang menarik bagi Anda",
  "payment_post_tax": "pajak ongkos kirim",
  "ORDER_PAID": "dibayar",
  "concactus_label5": "panggilan",
  "Item": "item",
  "Go_back": "kembali",
  "more": "lebih",
  "MyAccount": "akun saya",
  "payment_agree_1": "Saya menyetujui",
  "total_items": "total item",
  "shopping_go": "kelola alamat pengiriman",
  "ID_Type": "jenis ID",
  "after_sales_status": "status penjualan",
  "After_sales_apply": "ajukan penjualan",
  "Login": "masuk",
  "Quantity": "jumlah",
  "payment_post_fee": "biaya kirim",
  "MyAccount_Log_out": "Keluar",
  "Subtotal": "subtotal",
  "forgotPasswordConfirmation": "Terima kasih! Jika Anda mendaftar akun dengan email {0}, Anda akan menerima pesan di kotak masuk Anda yang berisi tautan pengaturan ulang kata sandi.",
  "MyAccount_Order_History_Tabs1": "Pesanan Saya",
  "concactus_img": "Unggah Gambar",
  "Done": "Selesai",
  "Info after order": "Anda dapat masuk ke akun Anda dengan email dan password yang telah Anda buat sebelumnya. Di akun Anda, Anda dapat mengedit profil pribadi, melihat riwayat transaksi, mengedit langganan newsletter, dan lainnya.",
  "MyAccoubnt_Set_newsletter": "Atur langganan newsletter Anda, kami akan mengirimkan informasi produk baru dan tren yang Anda pilih setiap minggu.",
  "Shipping_method": "Metode Pengiriman",
  "after_sales_refund": "Jumlah Refund",
  "After_sales_save": "Simpan Informasi Purna Jual",
  "go_order_history": "Lihat Riwayat Pemesanan",
  "contactus_message_placeholder": "Tulis komentar atau pertanyaan Anda di sini",
  "Login_Forgot_Password": "Jika Anda lupa password, Anda dapat meresetnya.",
  "show_more": "Lihat Lebih Banyak",
  "MyAccount_MyProfile_label_email": "email",
  "MyAccount_MyProfile_label2_pass3": "Ulangi Password",
  "Products": "Produk",
  "Review": "Ulasan",
  "MyAccount_MyProfile_title3": "Alamat email Anda saat ini adalah",
  "Category_found_Products": "Produk yang Ditemukan",
  "Match": "Kombinasi",
  "Read_all_reviews": "Baca semua ulasan",
  "Commercial information": "Saya menyetujui untuk menerima informasi pemasaran personal dari Brand name melalui email.",
  "Change password your account": "Jika Anda ingin mengubah kata sandi untuk akun Anda, silakan masukkan informasi di bawah ini.",
  "ID_Name": "Nama ID",
  "All": "Semua",
  "Instruction2": "Hanya butuh panduan perawatan?",
  "MyAccount_ShippingDetails_Add": "Tambah Alamat Baru",
  "MyAccount_MyShippingDetails_Zip": "Kode Pos",
  "go_pay_order": "Bayar Pesanan",
  "Thank_You_Inbox": "Jika pesan belum sampai di kotak masuk Anda, coba gunakan alamat email lain yang mungkin Anda gunakan untuk mendaftar.",
  "Subscribe": "Berlangganan",
  "confirm_subscription": "Saya mengkonfirmasi untuk berlangganan",
  "Login_input_Remember": "Ingat saya",
  "Add to compare": "Tambahkan ke perbandingan",
  "Brand": "Merek",
  "Start_shopping": "Mulailah Berbelanja",
  "Select shipping method": "Pilih Metode Pengiriman",
  "address CN": "Alamat di China, mata uang yang digunakan harus RMB",
  "MyAccount_MyShippingDetails_State": "Provinsi",
  "Page_not_found_message2": "Silakan kembali atau coba lagi",
  "Go_to_checkout": "Lanjut ke Pembayaran",
  "See all results": "Lihat Semua Hasil",
  "search_results_inputnull": "Anda belum mencari produk apa pun.",
  "subscribeToNewsletterModalContent": "Setelah berlangganan newsletter, Anda akan menerima penawaran khusus dan informasi dari VSF melalui email. Kami tidak akan pernah menjual atau membagikan alamat email Anda ke pihak ketiga. Silakan lihat Kebijakan Privasi kami untuk info lebih lanjut. {0}",
  "Download all": "Unduh Semua",
  "Login_input_last": "Nama Belakang",
  "Amount": "Jumlah",
  "ORDER_WAIT_PAYMENT": "Menunggu Pembayaran",
  "Order_After_sales": "Layanan Purna Jual Pesanan",
  "concattus_button": "Kirim",
  "Shipping_valid_required": "Item ini wajib diisi",
  "Price": "Harga",
  "ID_Type_Error": "Pilih tipe kartu identitas Anda",
  "Order_Status": "Status Pesanan",
  "Payment methods": "Metode Pembayaran",
  "MyAccount_MyProfile_Tab2": "Ubah kata sandi",
  "Show on page": "Tampilkan pada halaman",
  "Edit": "Edit",
  "Change": "Ubah",
  "MyAccount_ShippingDetails_Update": "Perbarui alamat",
  "View": "Lihat",
  "Privacy": "Privasi",
  "Enter_promo_code": "Masukkan kode promo",
  "Discount": "Diskon",
  "Delete": "Hapus",
  "Wishlist": "Daftar keinginan",
  "MyAccount_Order_History_Tabs3": "Pengembalian",
  "Go_To_Order_review": "Beri ulasan",
  "Update personal data": "Perbarui data pribadi",
  "payment_agree_2": "Ketentuan",
  "or fill the details below": "Atau isi detail di bawah ini",
  "Contact details updated": "Tetapkan alamat dan detail kontak terbaru Anda.",
  "Login_Create": "Buat akun",
  "Payment": "Pembayaran",
  "Billing": "Tagihan",
  "payment_insurance_tax": "Asuransi dan Pajak",
  "Size guide": "Panduan Ukuran",
  "Login_forgotten_password": "Lupa kata sandi?",
  "Login_no_account": "Belum punya akun?",
  "Privacy_Policy": "Kebijakan Privasi",
  "BootomCookieTitle": "Persetujuan Cookie",
  "Use your personal data": "Kami di Brand name sangat menjaga privasi dan melindungi data pribadi pengguna kami. Untuk informasi lebih lanjut tentang bagaimana kami peduli dan menggunakan data pribadi Anda, silakan lihat",
  "Review my order": "Periksa pesanan saya",
  "BootomCookieLink": "Pelajari lebih lanjut",
  "hide": "Sembunyikan",
  "MyAccount_ShippingDetails_message_title": "Kelola semua alamat pengiriman yang Anda inginkan (tempat kerja, rumah, dll.) sehingga Anda tidak perlu memasukkan alamat pengiriman secara manual di setiap pesanan.",
  "Purchase terms": "Syarat dan Ketentuan Pembelian",
  "Billing_address": "Alamat Tagihan",
  "Manage shipping addresses": "Kelola semua alamat pengiriman yang Anda inginkan (tempat kerja, rumah, dll.) sehingga Anda tidak perlu memasukkan alamat pengiriman secara manual di setiap pesanan.",
  "login_logbtn": "Masuk ke Akun",
  "choose_currency": "Pilih Mata Uang",
  "ORDER_REFUNDED": "Dikembalikan",
  "After_sales_form": "Isi formulir purna jual",
  "add_To_Wishlist": "Tambahkan ke Daftar Keinginan",
  "search_results_inputnull2": "Mulai sekarang, kami akan membantu Anda.",
  "Total": "Total",
  "Subscribe_to_newsletter": "Langganan newsletter",
  "Shipping_valid_Phone": "Silakan masukkan nomor telepon yang valid",
  "concactus_label3": "Judul",
  "Manage billing addresses": "Kelola semua alamat tagihan yang diinginkan (tempat kerja, rumah,...) sehingga Anda tidak perlu memasukkan alamat tagihan secara manual pada setiap pesanan.",
  "Search_results_title": "Hasil pencarian",
  "payment_order_payment": "Pembayaran pesanan",
  "after_sales_Id": "ID purna jual",
  "cart_title": "Keranjang Belanja Saya",
  "Order_Detail": "Detail pesanan",
  "concactus_label2": "Tautan Toko",
  "Shipping_valid_length_min": "Bidang ini harus memiliki minimal {min} karakter",
  "Product suggestions": "Saran Produk",
  "Return_home": "Kembali ke Beranda",
  "Quality in the details": "Kualitas di detail",
  "Continue_to_payment": "Lanjutkan ke Pembayaran",
  "Feedback": "Masukan Anda penting bagi kami. Beritahu kami apa yang dapat kami perbaiki.",
  "Go back to shop": "Kembali ke Toko",
  "Back_to_home": "Kembali ke Beranda",
  "Review_Content": "Isi ulasan",
  "add_To_Cart": "Tambahkan ke keranjang belanja",
  "Read_reviews": "Baca ulasan",
  "Instruction1": "Cara Perawatan",
  "Email_address": "Alamat email",
  "Category_Item_List": "Alihkan ke tampilan daftar",
  "Same as shipping address": "Sama dengan alamat pengiriman",
  "Category_Item_Grid": "Alihkan ke tampilan grid",
  "ID_Number_Error": "Silakan masukkan nomor identitas Anda",
  "concactus_label4": "Email kontak",
  "Additional_info": "Informasi Tambahan",
  "add_shipping": "Tambah Alamat Pengiriman Baru",
  "Product_description": "Karissa V-Neck Tee dirancang setengah ketat yang cocok untuk berbagai jenis tubuh. Dia merapat ke lekuk tubuh dan menyembunyikan area \"masalah\" yang umum sehingga Anda bisa percaya diri saat ke gym. Juga tersedia di gaun koktail wanita dan gaun pesta yang",
  "Login_create_account": "Saya menyetujui Syarat Penggunaan dan Kebijakan Pribadi",
  "after_sales_Reason": "Alasan service dijual",
  "MyAccount_MyProfile_label_Last": "Nama belakang",
  "MyAccount_MyProfile_label2_pass2": "Kata sandi baru",
  "Save": "Simpan",
  "CartSliderTextBtn": "Simpan untuk Pembelian Nanti",
  "Color": "Warna",
  "Shipping_Tax": "Biaya pengiriman pajak",
  "Subscribe_to_success": "Anda sudah berhasil berlangganan",
  "Enjoy your free account": "Nikmati keuntungan akun gratis Anda!",
  "cart_empty_desc": "Sepertinya Anda belum menambahkan produk apa pun ke keranjang belanja. Mulailah belanja untuk mengisinya.",
  "MyAccount_ShippingDetails_message_title2": "Simpan alamat dan informasi kontak Anda yang terbaru.",
  "An_error_occured": "Terjadi kesalahan",
  "Country": "Negara/Wilayah",
  "MyAccount_MyShippingDetails_First": "Nama depan",
  "payment_insurance_fee": "Biaya asuransi",
  "Home": "Beranda",
  "Contact_us": "Hubungi kami",
  "Cookies Policy": "Kebijakan Cookie",
  "match_goods": "Produk Terlaris",
  "Clear all": "Hapus semua",
  "Basket": "Keranjang belanja",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Kata sandi baru tidak sesuai",
  "Your current email address is": "Alamat email Anda saat ini adalah",
  "You currently have no orders": "Anda saat ini tidak memiliki pesanan",
  "Login_input_password": "Kata sandi",
  "Promo_code": "Kode promo",
  "order_count": "Jumlah pesanan",
  "email_geshi_error": "Masukkan alamat email yang valid",
  "your_email": "Email Anda",
  "email": "Email",
  "you_have_subscribed": "Anda telah berlangganan",
  "cancel_Subscribe": "Batalkan Langganan",
  "save_and_pay": "Simpan dan Bayar",
  "hasInsurance": "Beli asuransi?",
  "pleasePayType": "Silakan pilih metode pembayaran",
  "zhuanfa_toBePay": "Selesaikan pembayaran melalui teman anda",
  "linkCopied": "Tautan telah disalin, silakan paste dan bagikan ke teman",
  "Links": "Tautan",
  "article_category": "Kategori",
  "wechat_code_login_message": "Silakan gunakan scan kode QR WeChat untuk login",
  "wechat_code_login": "Login dengan scan kode QR WeChat",
  "Api_Update_success": "Pembaruan berhasil",
  "Please_Use_WeChat_login": "Silakan login dengan WeChat",
  "mobile_geshi_error": "Masukkan nomor telepon yang valid",
  "Login_input_email_required": "Masukkan email",
  "article_null": "Tidak ada artikel",
  "Login_with_microsoft": "Login dengan akun Microsoft",
  "article_null_des": "Anda dapat membuka artikel kategori lain",
  "register_email": "Email",
  "Login_tab_email": "Email",
  "code.time": "{time} detik lagi coba",
  "Login_with_wechat": "Login dengan WeChat",
  "cat_items_null_des": "Anda dapat membuka produk kategori lain",
  "Login_with_facebook": "Login dengan Facebook",
  "Login_input_code": "Kode verifikasi",
  "Login_input_mobile_required": "Masukkan nomor telepon",
  "Login_input_mobile": "Nomor telepon",
  "cat_items_null": "Tidak ada produk dalam kategori ini",
  "Login_with_twitter": "Login dengan Twitter",
  "mobile_code": "Kode verifikasi",
  "register_mobile": "Nomor telepon",
  "Login_tab_mobile": "Nomor telepon",
  "Login_with_google": "Login dengan Google",
  "OrderSku": "Spesifikasi produk",
  "Order_logisticsNo": "Nomor pengiriman",
  "order_shopping_firstname": "Nama lengkap",
  "Order_logisticsName": "Kurir",
  "ItemPrice": "Jumlah Barang",
  "inPayOrderAll": "Daftar Tertunda untuk Dibayar",
  "payPrice": "Jumlah yang Harus Dibayar",
  "shipping_add_success": "Pembuatan Alamat Pengiriman Berhasil",
  "pay_code_refresh": "Segarkan Kode Pembayaran",
  "pay_code_shixiao": "Kode Pembayaran Sudah Tidak Berlaku",
  "concactus_title": "Hubungi Kami",
  "Search_items": "Pencarian",
  "WebAutoLang": "Bahasa yang direkomendasikan browser Anda saat ini adalah: {lang}, apakah Anda ingin beralih ke bahasa tersebut?",
  "Services_Name": "Nama Layanan",
  "Services_Price": "Biaya Layanan",
  "SwichLang": "Ubah Bahasa",
  "Services_Description": "Deskripsi Layanan",
  "goodinfo_null": "tidak ada barang",
  "goodinfo_null_des": "Anda dapat menjelajahi barang-barang dari kategori lain",
  "notYetUseCode": "Belum menggunakan kode promo",
  "guest_Login": "Masuk sebagai tamu",
  "billing_and_shipping": "Tagihan dan alamat pengiriman sama",
  "select_coupon": "Pilih kupon",
  "select_gift": "Pilih hadiah",
  "currentUseCode": "Kode promo sudah digunakan",
  "shipping_refresh": "Segarkan daftar",
  "Shipping_details": "alamat pengiriman",
  "MyAccount_Newsletter": "berlangganan",
  "MyAccount_Profile": "Profil",
  "MyAccount_Wishlist": "Daftar Keinginan",
  "See_all": "Semua",
  "MyAccount_History": "Riwayat pesanan",
  "bind_microsoft": "Mengikat Microsoft",
  "bind_twitter": "Mengikat Twitter",
  "bind_facebook": "Mengikat Facebook",
  "bind_wechat_code": "Kode QR WeChat",
  "bind_wechat": "Mengikat WeChat",
  "bind_google": "Mengikat Google",
  "Wishlist_Empty": "Tidak ada daftar keinginan",
  "discount_post_fee": "Diskon ongkos kirim",
  "ORDER_PART_PAID": "Bayar sebagian",
  "claimCouponeSuccess": "Berhasil mengklaim {name}",
  "discount_kou": "{diskon} diskon",
  "claimCoupone": "klaim",
  "cartPreviewSafety_messageinfo": "Pengiriman aman dan cepat ke alamat Anda",
  "Order_No": "Nomor Pesanan",
  "cartPreviewSafety": "pengiriman aman",
  "Shipping": "pengiriman",
  "MyAccount_MyShippingDetails_Street": "jalan",
  "MyAccount_MyShippingDetails_HouseNumber": "nomor rumah",
  "Shipping_title": "alamat pengiriman",
  "Offline_payment": "Pembayaran Offline",
  "shopName": "Nama Toko",
  "Social": "Sosial",
  "SERVICE": "Layanan",
  "onlineContact": "Kontak online",
  "confirm": "Konfirmasi",
  "closeOrder": "Batalkan Pesanan",
  "closeOrderContext": "Apakah Anda yakin ingin membatalkan pesanan?",
  "Message_Read": "Sudah Dibaca",
  "close.order.success": "Berhasil Membatalkan Pesanan",
  "shippingAddress": "Alamat Lengkap",
  "Message": "Pesan",
  "Message_Empty_Title": "Pesan Anda kosong",
  "MyAccount_Message": "Pesan",
  "Message_Empty": "Tidak ada pesan",
  "payment_order_note": "Catatan pesanan",
  "go_to_see_prepid": "Klik di sini untuk melihat pesanan yang belum dibayar",
  "operate": "operasi",
  "removeCartItemContext": "Apakah Anda yakin ingin menghapus {title}？",
  "shippingItemQty": "kuantitas pengiriman",
  "removeCartItem": "Hapus barang",
  "shippingInfo": "informasi pengiriman",
  "Distributor_success": "Telah berhasil menjadi distributor",
  "Distributor_apply": "Mengajukan menjadi distributor",
  "Distributor_Details": "Distributor",
  "DistributorSataus": "Status",
  "Distributor_Details_Empty": "Tidak ada distributor",
  "distributor.status.4": "Dibatalkan",
  "distributor.status.1": "Tidak tersedia",
  "Distributor_copy_url": "Salin tautan distribusi",
  "Order_Time": "Waktu pesan",
  "Order_User": "Pemesan",
  "Distributor_copy_success": "Berhasil menyalin",
  "distributor.status.3": "Telah diselesaikan",
  "MyAccount_Distributor": "Distributor",
  "MyAccoubnt_Set_Distributor": "Mengajukan menjadi distributor",
  "distributor.status.2": "Dalam proses",
  "DistributorAmount": "Komisi",
  "Distributor_shenheshibai": "Verifikasi distri tidak lolos",
  "Distributor_shenhezhong": "Verifikasi distri sedang diproses",
  "Distributor_Order_Empty": "Tidak ada pesanan penjualan distri",
  "NE": "Niger",
  "DJ": "Djibouti",
  "KP": "Korea Utara",
  "US": "Amerika Serikat",
  "LC": "Saint Lucia",
  "NL": "Belanda",
  "CD": "Kongo-Kinshasa",
  "IS": "Islandia",
  "MA": "Maroko",
  "GH": "Ghana",
  "KR": "Korea Selatan",
  "MK": "Makedonia Utara",
  "HT": "Haiti",
  "PF": "Polinesia Prancis",
  "GA": "Gabon",
  "TD": "Chad",
  "LB": "Lebanon",
  "CG": "Kongo-Brazzaville",
  "KG": "Kirgizstan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "Timor Leste",
  "IN": "India",
  "NO": "Norwegia",
  "NG": "Nigeria",
  "AQ": "Antarktika",
  "LY": "Libya",
  "NI": "Nikaragua",
  "TT": "Trinidad dan Tobago",
  "HM": "Kepulauan Heard dan McDonald",
  "PY": "Paraguay",
  "BA": "Bosnia dan Herzegovina",
  "JP": "Jepang",
  "MD": "Moldova",
  "MT": "Malta",
  "RE": "Reunion",
  "UG": "Uganda",
  "SB": "Kepulauan Solomon",
  "SL": "Sierra Leone",
  "CV": "Tanjung Verde",
  "SD": "Sudan",
  "FO": "Kepulauan Faroe",
  "ZA": "Afrika Selatan",
  "TR": "Turki",
  "FK": "Kepulauan Falkland",
  "PA": "Panama",
  "GF": "Guyana Prancis",
  "TJ": "Tajikistan",
  "NC": "Kaledonia Baru",
  "PM": "Saint Pierre dan Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Belarus",
  "IM": "Pulau Man",
  "BI": "Burundi",
  "BS": "Bahama",
  "CK": "Kepulauan Cook",
  "MH": "Kepulauan Marshall",
  "CR": "Kosta Rika",
  "HK": "Hong Kong SAR China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Uni Emirat Arab",
  "GI": "Gibraltar",
  "CA": "Kanada",
  "AX": "Kepulauan Aland",
  "UY": "Uruguay",
  "WF": "Wallis dan Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Rusia",
  "PL": "Poland",
  "FM": "Mikronesia",
  "ET": "Etiopia",
  "EE": "Estonia",
  "SK": "Slowakia",
  "AS": "Samoa Amerika",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Vatikan",
  "TW": "China Taiwan",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Sahara Barat",
  "MO": "Wilayah Khusus Administratif Makau China",
  "MV": "Maladewa",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chili",
  "IL": "Israel",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Swedia",
  "GP": "Guadeloupe",
  "YE": "Yaman",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard dan Jan Mayen",
  "CO": "Kolombia",
  "LS": "Lesotho",
  "LV": "Latvia",
  "UM": "Kepulauan Terluar Amerika Serikat",
  "MX": "Meksiko",
  "DO": "Republik Dominika",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Kepulauan Turks dan Caicos",
  "VI": "Kepulauan Virgin AS",
  "FJ": "Fiji",
  "MP": "Kepulauan Mariana Utara",
  "AC": "Pulau Ascension",
  "NA": "Namibia",
  "SZ": "Swaziland",
  "RW": "Rwanda",
  "BH": "Bahrain",
  "KN": "Saint Kitts and Nevis",
  "TN": "Tunisia",
  "AF": "Afghanistan",
  "VG": "Kepulauan Virgin, Inggris",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Greenland",
  "SY": "Suriah",
  "CU": "Kuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "Cina",
  "MF": "Saint Martin",
  "NF": "Norfolk",
  "MZ": "Mozambik",
  "LU": "Luksemburg",
  "TO": "Tonga",
  "GR": "Yunani",
  "SI": "Slovenia",
  "PW": "Palau",
  "TZ": "Tanzania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Wilayah Selatan Prancis",
  "PS": "Palestina",
  "SC": "Seychelles",
  "BT": "Bhutan",
  "JM": "Jamaika",
  "BR": "Brasil",
  "CH": "Swiss",
  "SH": "Saint Helena",
  "HU": "Hungaria",
  "TM": "Turkmenistan",
  "LT": "Lituania",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Arab Saudi",
  "GB": "Inggris",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Kroasia",
  "SR": "Suriname",
  "CM": "Kamerun",
  "IQ": "Irak",
  "BO": "Bolivia",
  "MN": "Mongolia",
  "DZ": "Aljazair",
  "TK": " Tokelau",
  "MG": " Madagaskar",
  "YT": " Mayotte",
  "CC": " Kepulauan Cocos",
  "LA": " Laos",
  "PT": " Portugal",
  "QA": " Qatar",
  "AN": " Antilla Belanda",
  "PN": " Pitcairn",
  "ES": " Spanyol",
  "VC": " Saint Vincent dan Grenadines",
  "AU": " Australia",
  "CX": " Pulau Natal",
  "KM": " Komoro",
  "MR": " Mauritania",
  "FR": " Prancis",
  "SG": " Singapura",
  "BV": " Pulau Bouvet",
  "PH": " Filipina",
  "CY": " Siprus",
  "TV": " Tuvalu",
  "CF": " Republik Afrika Tengah",
  "EC": " Ekuador",
  "GW": " Guinea-Bissau",
  "IE": " Irlandia",
  "LK": " Sri Lanka",
  "ER": " Eritrea",
  "GQ": " Guinea Khatulistiwa",
  "NP": " Nepal",
  "BE": " Belgia",
  "GY": " Guyana",
  "DK": " Denmark",
  "MQ": " Martinik",
  "UZ": " Uzbekistan",
  "CI": " Pantai Gading",
  "ID": " Indonesia",
  "BJ": " Benin",
  "ST": " Sao Tome dan Principe",
  "KH": " Kamboja",
  "KZ": " Kazakhstan",
  "MS": " Montserrat",
  "TH": " Thailand",
  "FI": " Finlandia",
  "ML": " Mali",
  "AM": " Armenia",
  "IT": " Italia",
  "NR": " Nauru",
  "PG": " Papua Nugini",
  "ZW": " Zimbabwe",
  "JO": "Yordania",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "Selandia Baru",
  "VU": "Vanuatu",
  "DE": "Jerman",
  "CZ": "Republik Ceko",
  "DM": "Dominika",
  "KY": "Kepulauan Cayman",
  "BW": "Botswana",
  "RO": "Rumania",
  "PR": "Puerto Riko",
  "AZ": "Azerbaijan",
  "IO": "Wilayah Samudra Hindia Inggris",
  "UA": "Ukraina",
  "TG": "Togo",
  "MY": "Malaysia",
  "AG": "Antigua dan Barbuda",
  "EG": "Mesir",
  "GS": "Georgia Selatan dan Kepulauan Sandwich Selatan",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Semua",
  "post_state_country": "Ongkir: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "Kirim ke",
  "ShippingFee": "Biaya pengiriman",
  "reviewOutOf": "{rating} bintang, total 5 bintang",
  "product.pifa.label": "Beli {startnum} - {endnum} pcs",
  "product.pifa.type.1": "Diskon",
  "Write_a_review": "Menulis komentar",
  "BasedOnTotalReviews": "Berdasarkan {total} ulasan",
  "product.wholesale": "Harga grosir",
  "reviewMostRecent": "Ulasan terbaru",
  "product.pifa.type.2": "Harga satuan",
  "product.num.danwei": "orang",
  "good.shoppingDateLabel": "tanggal pengiriman",
  "good.shippingPeriod": "pengiriman dalam hari",
  "emailError": "Format email salah",
  "addressNote": "Catatan Alamat",
  "Concactus": "Kontak",
  "addressMessage": "Pastikan alamat Anda benar dan tidak salah. Setelah checkout, kami tidak dapat mengubah alamat.",
  "showOrderSummary": "Ringkasan Pesanan",
  "payment_method": "Metode Pembayaran",
  "emailNotNullError": "Email tidak boleh kosong",
  "orderCreateLoading": "Pembuatan Pesanan Sedang Berlangsung...",
  "emailNote": "Kontak",
  "emailMessage": "Pastikan alamat email Anda benar dan tidak salah. Kami akan mengirimkan email konfirmasi pesanan kepada Anda.",
  "payment_method_message": "Semua transaksi aman dan terenkripsi.",
  "go_buy_goods": "Lanjutkan Berbelanja",
  "tap_cancel_order": "Klik di sini untuk membatalkan pesanan",
  "order_review": "Ulasan Pesanan",
  "Add_new_address": "Tambahkan Alamat Baru",
  "promo_code_type_3": "Kupon Pengiriman Gratis",
  "IdCardNotNull": "Silakan isi informa...sebelumnya",
  "promo_code_type_1": "Kupon Potongan Harga",
  "shippingInfoNotNull": "Informasi Pengiriman Tidak Lengkap",
  "UploadVideo": "Unggah video",
  "video": "Video",
  "UploadImage": "Unggah gambar",
  "uploadImageing": "Sedang mengunggah...",
  "BillingInfoNotNull": "Info tagihan tidak lengkap",
  "promo_code_type_2": "Kupon Tunai",
  "UploadError": "Gagal mengunggah",
  "promo_code_type_4": "Diskon biaya pengiriman",
  "image": "Gambar",
  "paymentMethodNotNull": "Harap pilih metode pembayaran",
  "reviewDetail": "Detail ulasan",
  "DeliveryCountry": "Area pengiriman",
  "prompt_error": "pesan_error",
  "save_review_success": "sukses_meninjau",
  "ORDER_COMPLETED": "Selesai",
  "crate_after_sales": "Membuat layanan purna jual",
  "Thank_You_Order": "Terima kasih atas pesanan Anda!",
  "Thank_You_Order_sub": "Kami akan segera memproses pesanan Anda dan Anda akan menerima email yang mengandung informasi tentang pemrosesan pesanan.",
  "BootomCookieContext": "Situs web ini menggunakan cookies untuk membantu situs web berjalan dengan normal dan membantu kami memahami bagaimana berinteraksi dengan itu. Kami menggunakan cookies ini untuk memberikan pengalaman pengguna yang lebih baik dan dipersonalisasi. Jika And",
  "order_reivice_message": "Apakah Anda yakin sudah menerima barangnya?",
  "order_reivice_btn": "Konfirmasi Penerimaan",
  "order_reivice_label": "Penerimaan Pesanan",
  "order_reivice_success": "Konfirmasi Penerimaan Berhasil",
  "collpase_show": "Lihat Lebih Banyak",
  "collpase_hide": "Lipat",
  "CouponCode": "kode kupon",
  "wechatPayScannerCode": "Silakan gunakan WeChat untuk melakukan pembayaran dengan memindai kode QR",
  "processing": "Proses purna jual",
  "finished": "Purna jual telah selesai",
  "login.showPrice": "Lihat harga setelah login",
  "After_Sales_Unknown": "Status purna jual tidak diketahui",
  "order_payment_list_null": "Tidak ada pesanan yang menunggu pembayaran",
  "Cancel": "Batalkan",
  "thankyou_concat": "Jika ada pertanyaan, silakan hubungi kami"
}